// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"cae7af93","787":"b490299a"}[chunkId] + ".chunk.js";
};